import React from 'react';
import { graphql, Link } from 'gatsby';

import GraphQLErrorList from '../components/graphql-error-list';
import SEO from '../components/layout/seo';
import { capitalizeFirstLetter } from '../lib/helpers';
import Cyclelayout from '../components/cyclelayout';
import ContentSections from '../components/pagebuilder/content-sections';
import { grid } from '../components/pagebuilder/section-grid/grid.module.css';
import ItemCell from '../components/itemCell';
import Container from '../components/layout/container';
import Section from '../components/sections/section';
import SectionTitle from '../components/reusecore/SectionTitle';
import Heading from '../components/reusecore/Heading';
import { Col, Row } from '../components/reusecore/Layout';
import SidebarProduct from '../components/layout/sidebarProduct';
import SectionHero from '../components/pagebuilder/section-hero';
import Navigation from '../components/sections/cycle/Navigation';
import { sortByItemType } from '../utils/tools';

export const query = graphql`
  query ShopPageQuery {
    gatsby: site {
      config: siteMetadata {
        siteUrl
        title
        description
        userTwitter
      }
    }
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
    }
    page: sanityPage(slug: { current: { eq: "shop" } }) {
      ...Page
    }
    items: allSanityItem(filter: { slug: { current: { ne: null } } }) {
      nodes {
        ...Item
      }
    }
    manufacturers: allSanityManufacturer(
      filter: { slug: { current: { ne: null } } }
      sort: { fields: _updatedAt, order: DESC }
    ) {
      nodes {
        ...Manufacturer
      }
    }
    itemTypes: allSanityItemType(
      filter: { slug: { current: { ne: null } } }
      sort: { fields: _updatedAt, order: DESC }
    ) {
      nodes {
        ...ItemType
      }
    }
  }
`;

const ShopPage = (props) => {
  const { data, errors, location } = props;

  if (errors) {
    return (
      <Cyclelayout>
        <GraphQLErrorList errors={errors} />
      </Cyclelayout>
    );
  }

  const {
    gatsby: { config },
    site,
    page,
    items,
    itemTypes,
    manufacturers,
  } = data;

  const { hero, smallHero } = page;
  const sortedItemTypes = sortByItemType(itemTypes);
  // console.log('sortedItemTypes: ', sortedItemTypes);

  let { search = '', state, hash } = location;
  let searchSlug = '';
  let searchType = '';
  if (search.includes('tag')) {
    searchSlug = decodeURIComponent(search.replace('?tag=', ''));
  }

  let title = '';
  if (searchSlug !== '') {
    title = `${capitalizeFirstLetter(searchSlug)}`;
  }

  return (
    <>
      <Navigation />
      <SectionHero smallHero={smallHero} hero={hero} />
      <SEO
        title={page.title}
        description={page.seo?.meta_description}
        keywords={page.seoKeywords || site.keywords}
        seoTitle={page.seo?.seo_title}
        seoImage={page.seoImage?.asset?.img?.src}
        path={props.location.pathname}
      />
      <main>
        <Section>
          <Container>
            {page && page.content && <ContentSections content={page.content} />}
            <Row reverseMobile>
              <Col xs={12} lg={3}>
                <SidebarProduct itemTypes={sortedItemTypes} manufacturers={manufacturers} items={items} />
              </Col>
              <Col xs={12} lg={9}>
                <Row>
                  <Col className="xs-12">
                    {searchSlug !== '' ? (
                      <>
                        <Heading as="h1">{title}</Heading>
                        <ol className={grid}>
                          {items?.nodes?.map((item) => {
                            if (item.tags.find((tag) => tag.value.toLowerCase() === searchSlug)) {
                              return (
                                <li id={item.id} key={item.id}>
                                  <ItemCell noMargin item={item} />
                                </li>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </ol>
                      </>
                    ) : (
                      sortedItemTypes?.map((itemType) => (
                        <div key={itemType.id}>
                          <SectionTitle UniWidth="65%">
                            <Heading id={itemType.id} as="h2">
                              <Link to={`/${itemType.slug.current}`}>{itemType.title}</Link>
                            </Heading>
                          </SectionTitle>

                          {manufacturers?.nodes?.map((manufacturer) => {
                            const manufacturerItemTypeFound = items?.nodes?.find((item) => {
                              return item.itemType.id === itemType.id && manufacturer?.id === item.manufacturer?.id;
                            });

                            return manufacturerItemTypeFound ? (
                              <div key={manufacturer.id}>
                                <SectionTitle UniWidth="65%">
                                  <Heading id={manufacturer.id} as="h3">
                                    <Link to={`/${itemType.slug.current}/${manufacturer.slug.current}`}>
                                      {manufacturer.name}
                                    </Link>
                                  </Heading>
                                </SectionTitle>
                                <ol className={grid}>
                                  {items?.nodes?.map((item) => {
                                    if (
                                      item.itemType?.id === itemType?.id &&
                                      manufacturer?.id === item.manufacturer?.id
                                    ) {
                                      return (
                                        <li id={item.id} key={item.id}>
                                          <ItemCell noMargin item={item} />
                                        </li>
                                      );
                                    } else {
                                      return null;
                                    }
                                  })}
                                </ol>
                              </div>
                            ) : null;
                          })}
                        </div>
                      ))
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Section>
      </main>
    </>
  );
};

export default ShopPage;
